const includesText = (value, expected) =>
  (value || '').toLowerCase().includes((expected || '').toLowerCase());

export const BOT_TEST_CASES = [
  {
    id: 'quartz_catalogue',
    title: 'Quartz Catalogue',
    query: 'quartz catalogue',
    description: 'Checks that the bot returns the Quartz catalogue with a direct PDF-ready document payload.',
  },
  {
    id: 'collection_images',
    title: 'Collection Images',
    query: 'neo paris collection image',
    description: 'Checks that a collection image request returns a useful image response for a collection.',
  },
  {
    id: 'instruction_manuals',
    title: 'Instruction Manuals',
    query: 'installation manual',
    description: 'Checks that instruction manual requests return instruction-manual guidance.',
  },
  {
    id: 'installation_images',
    title: 'Installation Images',
    query: 'Show installation images for Lincoln White',
    description: 'Checks that installation image lookups resolve to a specific useful folder response.',
  },
  {
    id: 'render_specific_product',
    title: 'Specific Render',
    query: 'Can you show me a render of bianco thasos',
    description: 'Checks typo-tolerant render lookup for a specific product/design.',
  },
];

export const evaluateBotTestCase = (testCase, payload) => {
  const reply = payload?.catalog_reply || {};
  const replyText = reply.reply_text || '';
  const replyType = reply.type || '';
  const imageCount = Array.isArray(reply.images) ? reply.images.length : 0;
  const documentCount = Array.isArray(reply.documents) ? reply.documents.length : 0;
  const sourceTreeMatchCount = Array.isArray(payload?.source_tree_matches) ? payload.source_tree_matches.length : 0;

  switch (testCase.id) {
    case 'quartz_catalogue': {
      const passed =
        replyType === 'catalogue_link' &&
        includesText(replyText, 'Quartz catalogue') &&
        (documentCount >= 1 || includesText(replyText, 'PDF directly'));
      return {
        passed,
        note: passed
          ? 'Quartz catalogue came back with a direct document payload.'
          : `Expected a direct Quartz catalogue document, got type "${replyType || 'none'}" with ${documentCount} document(s).`,
      };
    }
    case 'collection_images': {
      const passed =
        ['collection_images', 'source_tree_node'].includes(replyType) &&
        (imageCount > 0 || includesText(replyText, 'Paris'));
      return {
        passed,
        note: passed
          ? `Collection image flow responded as "${replyType}" with ${imageCount} image(s).`
          : `Expected a collection image response, got type "${replyType || 'none'}".`,
      };
    }
    case 'instruction_manuals': {
      const passed =
        ['source_tree_disambiguation', 'source_tree_node', 'installation_guidance'].includes(replyType) &&
        includesText(replyText, 'instruction manual');
      return {
        passed,
        note: passed
          ? 'Instruction manual response includes manual guidance.'
          : `Expected instruction manual guidance, got type "${replyType || 'none'}".`,
      };
    }
    case 'installation_images': {
      const passed =
        ['source_tree_node', 'design'].includes(replyType) &&
        includesText(replyText, 'Lincoln White') &&
        (includesText(replyText, 'installation') || imageCount > 0 || sourceTreeMatchCount > 0);
      return {
        passed,
        note: passed
          ? `Installation image lookup returned a Lincoln White response as "${replyType}" with ${imageCount} image(s).`
          : `Expected a Lincoln White installation-image response, got type "${replyType || 'none'}".`,
      };
    }
    case 'render_specific_product': {
      const passed =
        replyType === 'design' &&
        includesText(replyText, 'Bianco Thassos') &&
        imageCount > 0;
      return {
        passed,
        note: passed
          ? `Specific render lookup returned ${imageCount} image(s).`
          : `Expected a render response for Bianco Thassos, got type "${replyType || 'none'}".`,
      };
    }
    default:
      return { passed: false, note: 'Unknown test case.' };
  }
};

export const buildBotTestReport = (results) => {
  const passed = results.filter((result) => result.passed).length;
  const lines = [
    '# Bot Feature Test Report',
    '',
    `Total checks: ${results.length}`,
    `Passed: ${passed}`,
    `Failed: ${results.length - passed}`,
    '',
  ];

  results.forEach((result, index) => {
    lines.push(`${index + 1}. ${result.title}`);
    lines.push(`Status: ${result.passed ? 'PASS' : 'FAIL'}`);
    lines.push(`Query: ${result.query}`);
    lines.push(`Description: ${result.description}`);
    lines.push(`Result: ${result.note}`);
    lines.push(`Reply type: ${result.replyType || 'n/a'}`);
    lines.push('');
  });

  return lines.join('\n');
};
